<template>
  <video id="player-container-id" preload="auto" playsinline webkit-playsinline>
  </video>
</template>

<script>
import TCPlayer from 'tcplayer.js';
import 'tcplayer.js/dist/tcplayer.min.css';

export default {
  props: {
    source: {
      type: String,
      default: "",
    },
    cover: {
      type: String,
      default: "",
    },
    autoplay: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
    };
  },
  mounted() {
    let _source
    if (/^(https?)/.test(this.source)) {
      _source = this.source;
    } else {
      _source = process.env.VUE_APP_BASE_API + this.source;
    }

    let poster
    if (/^(https?)/.test(this.cover)) {
      poster = this.cover;
    } else {
      poster = process.env.VUE_APP_BASE_API + this.cover;
    }

    let width = window.outerWidth
    let height = width * 9 / 16

    // 先判断是否已存在播放器实例，避免重复初始化报错
    const existingPlayer = (TCPlayer.players || {})['player-container-id'];
    if (existingPlayer) {
      existingPlayer.dispose();
    }

    // player-container-id 为播放器容器 ID，必须与 html 中一致
    this.player = TCPlayer('player-container-id', {
      sources: [{
        // src: 'https://sf1-cdn-tos.huoshanstatic.com/obj/media-fe/xgplayer_doc_video/hls/xgplayer-demo.m3u8'
        src: _source
      }],
      licenseUrl: 'https://1306385042.trtcube-license.cn/license/v2/1306385042_1/v_cube.license', // license 地址，必传。参考准备工作部分，在视立方控制台申请 license 后可获得 licenseUrl
      autoplay: this.autoplay,
      poster: poster,
      width: width,
      height: height
    });

  },
  methods: {
    play() {
      if (this.player) {
        this.player.play();
      }
      this.$emit("play");
    },
    src(url) {
      if (this.player) {
        this.player.src(url);
      }
    },
    aliPlayerTouchStart() {
      this.$emit('handleShowPlayNumber')
    },
  },
};
</script>

<style lang="less">
video {
  object-fit: fill;
}
.player-container-id-dimensions {
  width: 100%;
}
div .vjs-error-display {
 display: none;
}
</style>
